module.exports = __webpack_public_path__ + "media/images/icons/notifications_active-f649aaedb86836633e8ae091bfb6c358.svg";